import { ProductStatusConstant, ProductStatusType } from '../../constants/product/product.constant';
import { IProduct } from '../../interfaces/Product.interfaces';
import { calculateAnonymousUserPrice } from '../calculator/calculatePrice.util';
import { formatPrice } from '../formatter/formatPrice.util';

interface IGetProductPriceParams {
  product: IProduct;
  isUserLoggedIn: boolean;
}

export const getOpenMarketProductPrice = (status: ProductStatusType, price: number): string => {
  if (status !== ProductStatusConstant.SOLDOUT) {
    return `${formatPrice(price)}원`;
  }

  return getPriceMessageByStatus(status);
};

export const getGeneralProductPrice = ({ product, isUserLoggedIn }: IGetProductPriceParams): string => {
  const loggedInUserPrice = `${formatPrice(product.price)}원`;
  const anonymousUserPrice = `${formatPrice(calculateAnonymousUserPrice(product.priceDetails))}원`;

  const getProductPriceByUserLoggedIn = (): string => {
    if (isUserLoggedIn) {
      return loggedInUserPrice;
    }

    if (product.priceDetails.length > 0) {
      return anonymousUserPrice;
    }

    // 에러
    return '정가 등록 예정';
  };

  // 가격 공개 시
  if (product.priceVisible) {
    return getProductPriceByUserLoggedIn();
  }

  return getPriceMessageByStatus(product.status);
};

const getPriceMessageByStatus = (status: string): string => {
  switch (status) {
    case 'PENDING':
      // 판매예정 상태
      return '가격 추후 공개';
    case 'ONSALE':
    case 'IN_CONTRACT':
      // 가격 미공개 시 & 판매중 및 계약진행중 상태
      return '가격 미공개';
    case 'SOLDOUT':
      // 가격 미공개 시 & 판매완료 상태
      return '판매 완료';
    default:
      return '가격 점검 중';
  }
};
